"use client";

import { useState } from "react";
import Loading from "@/components/Loading";
import { displayValue, StatusComponent } from "@/components/OtherBetsDropdown";

export default function FinanceeOtherBetsDropdown({
  loadingOtherOdds,
  otherOddsData,
  hasOtherData,
  isLive,
  goalOddEvenOdds = [],
  goalOddEvenFirst = {},
  correctScoresListFull = [],
  correctScoresFull = { home: [], draw: [], away: [] },
  correctScoresListHalf = [],
  correctScoresHalf = { home: [], draw: [], away: [] },
  totalCornersOdds = [],
  totalCornersHalfOdds = [],
  fontBody = "text-[13px]",
}) {
  const [activeOtherTab, setActiveOtherTab] = useState("full");

  return (
    <div className="px-2 md:px-4 pt-[15px] pb-8 min-w-0 overflow-hidden">
      {loadingOtherOdds && !otherOddsData && (
        <div className="w-full py-4">
          <Loading />
        </div>
      )}
      {!loadingOtherOdds && otherOddsData && !hasOtherData && (
        <div className={`w-full py-2 text-center text-[var(--theme-text-muted)] ${fontBody}`}>Chưa có dữ liệu kèo cược khác</div>
      )}
      {!loadingOtherOdds && hasOtherData && (
        <div className={`kbv-ktm-panel flex flex-col gap-0 min-w-0 overflow-hidden rounded-md p-0 ${isLive ? "kbv-ktm-panel--live" : "kbv-ktm-panel--not-live"}`}>
          <div className="kbv-ktm-tab-line w-full border-b">
            <ul className="flex w-[200px]">
              <li className="w-1/2 shrink-0">
                <button
                  type="button"
                  onClick={() => setActiveOtherTab("full")}
                  className={`w-full py-2 px-3 font-bold ${fontBody} border-0 ${activeOtherTab === "full" ? "kbv-ktm-tab--active" : "kbv-ktm-tab--inactive"}`}
                >
                  Cả trận
                </button>
              </li>
              <li className="w-1/2 shrink-0">
                <button
                  type="button"
                  onClick={() => setActiveOtherTab("half")}
                  className={`w-full py-2 px-3 font-bold ${fontBody} border-0 ${activeOtherTab === "half" ? "kbv-ktm-tab--active" : "kbv-ktm-tab--inactive"}`}
                >
                  Hiệp 1
                </button>
              </li>
            </ul>
          </div>

          <div className="p-2.5 flex flex-col gap-3">
            {activeOtherTab === "full" && (
              <>
                {goalOddEvenOdds?.length > 0 && (
                  <div className="flex flex-col gap-1">
                    <div className={`font-bold text-[var(--theme-text-muted)] ${fontBody}`}>Odd/Even</div>
                    <div className="flex flex-wrap gap-2">
                      <div className="flex flex-col items-center gap-0.5">
                        <span className="text-xxs text-[var(--theme-text-muted)]">Odd</span>
                        <span className={`flex items-center justify-center gap-1 bg-[var(--theme-foreground)] text-[var(--theme-text)] font-bold rounded-md py-1 px-2 min-w-[4rem] ${fontBody}`}>
                          {displayValue(goalOddEvenFirst?.single)}
                          <StatusComponent trend={goalOddEvenFirst?.initialSingleTrend} />
                        </span>
                      </div>
                      <div className="flex flex-col items-center gap-0.5">
                        <span className="text-xxs text-[var(--theme-text-muted)]">Even</span>
                        <span className={`flex items-center justify-center gap-1 bg-[var(--theme-foreground)] text-[var(--theme-text)] font-bold rounded-md py-1 px-2 min-w-[4rem] ${fontBody}`}>
                          {displayValue(goalOddEvenFirst?.double)}
                          <StatusComponent trend={goalOddEvenFirst?.initialDoubleTrend} />
                        </span>
                      </div>
                    </div>
                  </div>
                )}
                {correctScoresListFull.length > 0 && (
                  <div className="flex flex-col gap-1">
                    <div className={`font-bold text-[var(--theme-text-muted)] ${fontBody}`}>Tổng tỷ số</div>
                    <div className="grid grid-cols-3 gap-1 mb-0.25 text-center font-bold text-[10px] text-[var(--theme-text-muted)]">
                      {correctScoresFull.home?.length > 0 && <div className="py-1.5 px-2">Tỉ Số Thắng Đội Nhà</div>}
                      {correctScoresFull.draw?.length > 0 && <div className="py-1.5 px-2">Tỉ Số Hòa</div>}
                      {correctScoresFull.away?.length > 0 && <div className="py-1.5 px-2">Tỉ Số Thắng Đội Khách</div>}
                    </div>
                    <div className="max-h-[250px] overflow-y-auto min-h-0">
                      <div className="grid grid-cols-3 gap-2.5">
                        {correctScoresFull.home?.length > 0 && (
                          <div className="flex flex-col gap-1.5">
                            {correctScoresFull.home.map((item, idx) => (
                              <div key={idx} className="flex flex-col gap-1.5 min-w-0 shrink-0">
                                <div className={`text-[var(--theme-text-muted)] text-center py-1.5 ${fontBody}`}>{item.label}</div>
                                <div className={`bg-[var(--theme-foreground)] text-[var(--theme-text)] font-bold text-center rounded-md py-1.5 ${fontBody}`}>{item.value}</div>
                              </div>
                            ))}
                          </div>
                        )}
                        {correctScoresFull.draw?.length > 0 && (
                          <div className="flex flex-col gap-1.5">
                            {correctScoresFull.draw.map((item, idx) => (
                              <div key={idx} className="flex flex-col gap-1.5 min-w-0 shrink-0">
                                <div className={`text-[var(--theme-text-muted)] text-center py-1.5 ${fontBody}`}>{item.label}</div>
                                <div className={`bg-[var(--theme-foreground)] text-[var(--theme-text)] font-bold text-center rounded-md py-1.5 ${fontBody}`}>{item.value}</div>
                              </div>
                            ))}
                          </div>
                        )}
                        {correctScoresFull.away?.length > 0 && (
                          <div className="flex flex-col gap-1.5">
                            {correctScoresFull.away.map((item, idx) => (
                              <div key={idx} className="flex flex-col gap-1.5 min-w-0 shrink-0">
                                <div className={`text-[var(--theme-text-muted)] text-center py-1.5 ${fontBody}`}>{item.label}</div>
                                <div className={`bg-[var(--theme-foreground)] text-[var(--theme-text)] font-bold text-center rounded-md py-1.5 ${fontBody}`}>{item.value}</div>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}
                {totalCornersOdds.length > 0 && (
                  <div className="flex flex-col gap-1">
                    <div className={`font-bold text-[var(--theme-text-muted)] ${fontBody}`}>Tổng Phạt Góc</div>
                    <div className="flex flex-wrap gap-2">
                      {totalCornersOdds.map((item, idx) => (
                        <div key={idx} className={`flex items-center gap-2 bg-[var(--theme-foreground)] text-[var(--theme-text)] rounded-md py-1 px-2 ${fontBody}`}>
                          <span>{displayValue(item?.totalCorners)}</span>
                          <span className="flex items-center gap-0.5">Tài {displayValue(item?.over)}<StatusComponent trend={item?.initialOverTrend} /></span>
                          <span className="flex items-center gap-0.5">Xỉu {displayValue(item?.under)}<StatusComponent trend={item?.initialUnderTrend} /></span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </>
            )}

            {activeOtherTab === "half" && (
              <>
                {correctScoresListHalf.length > 0 && (
                  <div className="flex flex-col gap-1">
                    <div className={`font-bold text-[var(--theme-text-muted)] ${fontBody}`}>Tổng tỷ số</div>
                    <div className="grid grid-cols-3 gap-1 mb-0.25 text-center font-bold text-[10px] text-[var(--theme-text-muted)]">
                      {correctScoresHalf.home?.length > 0 && <div className="py-1.5 px-2">Tỉ Số Thắng Đội Nhà</div>}
                      {correctScoresHalf.draw?.length > 0 && <div className="py-1.5 px-2">Tỉ Số Hòa</div>}
                      {correctScoresHalf.away?.length > 0 && <div className="py-1.5 px-2">Tỉ Số Thắng Đội Khách</div>}
                    </div>
                    <div className="max-h-[250px] overflow-y-auto min-h-0">
                      <div className="grid grid-cols-3 gap-2.5">
                        {correctScoresHalf.home?.length > 0 && (
                          <div className="flex flex-col gap-1.5">
                            {correctScoresHalf.home.map((item, idx) => (
                              <div key={idx} className="flex flex-col gap-1.5 min-w-0 shrink-0">
                                <div className={`text-[var(--theme-text-muted)] text-center py-1.5 ${fontBody}`}>{item.label}</div>
                                <div className={`bg-[var(--theme-foreground)] text-[var(--theme-text)] font-bold text-center rounded-md py-1.5 ${fontBody}`}>{item.value}</div>
                              </div>
                            ))}
                          </div>
                        )}
                        {correctScoresHalf.draw?.length > 0 && (
                          <div className="flex flex-col gap-1.5">
                            {correctScoresHalf.draw.map((item, idx) => (
                              <div key={idx} className="flex flex-col gap-1.5 min-w-0 shrink-0">
                                <div className={`text-[var(--theme-text-muted)] text-center py-1.5 ${fontBody}`}>{item.label}</div>
                                <div className={`bg-[var(--theme-foreground)] text-[var(--theme-text)] font-bold text-center rounded-md py-1.5 ${fontBody}`}>{item.value}</div>
                              </div>
                            ))}
                          </div>
                        )}
                        {correctScoresHalf.away?.length > 0 && (
                          <div className="flex flex-col gap-1.5">
                            {correctScoresHalf.away.map((item, idx) => (
                              <div key={idx} className="flex flex-col gap-1.5 min-w-0 shrink-0">
                                <div className={`text-[var(--theme-text-muted)] text-center py-1.5 ${fontBody}`}>{item.label}</div>
                                <div className={`bg-[var(--theme-foreground)] text-[var(--theme-text)] font-bold text-center rounded-md py-1.5 ${fontBody}`}>{item.value}</div>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}
                {totalCornersHalfOdds.length > 0 && (
                  <div className="flex flex-col gap-1">
                    <div className={`font-bold text-[var(--theme-text-muted)] ${fontBody}`}>Tổng Phạt Góc</div>
                    <div className="flex flex-wrap gap-2">
                      {totalCornersHalfOdds.map((item, idx) => (
                        <div key={idx} className={`flex items-center gap-2 bg-[var(--theme-foreground)] text-[var(--theme-text)] rounded-md py-1 px-2 ${fontBody}`}>
                          <span>{displayValue(item?.totalCorners)}</span>
                          <span className="flex items-center gap-0.5">Tài {displayValue(item?.over)}<StatusComponent trend={item?.initialOverTrend} /></span>
                          <span className="flex items-center gap-0.5">Xỉu {displayValue(item?.under)}<StatusComponent trend={item?.initialUnderTrend} /></span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
